import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'retailer_team_sharing-invite_user_lean_flow-click';

/**
 * Invite sent from lean invite modal flow
 */
export function trackRetailerTeamSharingInviteUserLeanFlowClick(
  customParameterToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { customParameterToken },
  });
}
